import Swal from 'sweetalert2'

/**
 * Muestra un modal SweetAlert2 de exito con titulo, texto, refetch y close opcionales.
 */
export const alertSuccess = (
  title: string,
  text: string,
  refetch: Function = () => {},
  close: Function = () => {}
) => {
  Swal.fire({
    title: title,
    icon: 'success',
    text: text,
    confirmButtonText: 'Entendido',
    allowOutsideClick: true,
    allowEscapeKey: true,
  }).then((result) => {
    if (result.isConfirmed) {
      refetch && refetch()
      close && close()
    }
  })
}
